<template>
    <Teleport to="body">
        <VJoyDropdownList v-if="visible" class="table-context-menu" :style="{top: `${y}px`, left: `${x}px`}" width="220" height="auto">
            <template #dropdown-list-items>
                <VJoyMenuItem label="Add column before" icon="arrow-left" type="button" @click="run(addColumnBefore)" />
                <VJoyMenuItem label="Add column after" icon="arrow-right" type="button" @click="run(addColumnAfter)" />
                <VJoyMenuItem label="Delete column" icon="trash" type="button" @click="run(deleteColumn)" />
                <VJoyMenuItem label="Add row before" icon="arrow-left" type="button" @click="run(addRowBefore)" />
                <VJoyMenuItem label="Add row after" icon="arrow-right" type="button" @click="run(addRowAfter)" />
                <VJoyMenuItem label="Delete row" icon="trash" type="button" @click="run(deleteRow)" />
                <VJoyMenuItem label="Delete table" icon="trash" type="button" @click="run(deleteTable)" />
            </template>
        </VJoyDropdownList>
    </Teleport>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {VJoyDropdownList, VJoyMenuItem} from '@maltjoy/core-vue';
    import {useDocumentListener} from '~/features/portfolio/editor/composable/useDocumentListener';

    const {addColumnBefore, addColumnAfter, deleteColumn, addRowBefore, addRowAfter, deleteRow, deleteTable} = defineProps<{
        addColumnBefore: () => void;
        addColumnAfter: () => void;
        deleteColumn: () => void;
        addRowBefore: () => void;
        addRowAfter: () => void;
        deleteRow: () => void;
        deleteTable: () => void;
    }>();

    const visible = ref(false);
    const x = ref(0);
    const y = ref(0);

    const MENU_HEIGHT = 280;

    function show(clientX: number, clientY: number) {
        x.value = clientX;
        y.value = window.innerHeight - clientY < MENU_HEIGHT ? clientY - MENU_HEIGHT : clientY;
        visible.value = true;
    }

    function hide() {
        visible.value = false;
    }

    function run(action: () => void) {
        action();
        hide();
    }

    useDocumentListener('click', hide);

    defineExpose({show});
</script>

<style lang="scss" scoped>
    .table-context-menu {
        position: fixed !important;
        z-index: 1081;
        max-height: none !important;
        overflow: visible !important;
    }

    :deep(.joy-dropdown-list__items-slotted) {
        padding: 0 !important;
    }
</style>
